export function formatJson(value) {
    try {
        return JSON.stringify(JSON.parse(value), null, 2);
    } catch  {
        return value;
    }
}

//# sourceMappingURL=formatJson.js.map